<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0037 3C14.7653 3 17.0037 5.25245 17.0037 8.01894C17.0037 10.7857 14.7654 13.0385 12.0037 13.0385C9.24202 13.0385 7.00375 10.7856 7.00375 8.01894C7.00375 5.25249 9.24211 3 12.0037 3ZM15.1628 14.1514C14.4132 13.8419 13.5509 14.0156 12.9797 14.5913L12.0267 15.55L11.0758 14.5913L10.9578 14.4815C10.3901 13.9946 9.59232 13.8625 8.89272 14.1514C6.67736 15.0664 4.49089 16.4353 3.44007 17.753C2.39539 19.0631 3.32818 21 5.00375 21H19.0518L19.202 20.9947C20.7821 20.8832 21.6285 19.0234 20.6155 17.753C19.5646 16.4353 17.3782 15.0664 15.1628 14.1514ZM12.5348 17.8791L14.3994 16L14.7081 16.1312C16.2662 16.8116 18.019 17.8499 18.8971 18.8186L19.0518 19H5.00375L5.15844 18.8186C6.09509 17.7854 8.02693 16.6729 9.65616 16L11.5207 17.8791L11.6036 17.9521C11.89 18.1713 12.2691 18.1469 12.5348 17.8791ZM9.00375 8.01894C9.00375 6.3542 10.3496 5 12.0037 5C13.6579 5 15.0037 6.3542 15.0037 8.01894C15.0037 9.62453 13.7524 10.9414 12.1797 11.0334L12.0037 11.0385L11.8277 11.0334C10.2551 10.9414 9.00375 9.62453 9.00375 8.01894Z"
      fill="#636363"
    />
  </svg>
</template>
